import { useRef } from 'react';
import PropTypes from 'prop-types';
import useModalA11y from '../../../hooks/useModalA11y';
import { ICON_BUTTON_ICONS } from '../../buttons/IconButton';
import { SUPPORT_EMAIL } from '../../../utils/constants/subscription';

// TD-2119 R3: Shown once per session when the company's total token pool
// transitions from "available" to "exhausted". One-time per browser session
// is symmetric with the R2d fallback modal — sessionStorage prevents
// re-show on F5; closing the tab + reopening shows it again.
//
// Native <dialog> (TD-2120 Item 2): showModal() in useModalA11y supplies focus
// trap, Escape, aria-modal, top-layer and ::backdrop. The padding-less <dialog>
// is the backdrop (a click on it light-dismisses via the hook); the inner
// .onhold-modal-dialog is the visible box.
const OnHoldActivationModal = ({ isOpen, onClose }) => {
  const dialogRef = useRef(null);
  useModalA11y({ isOpen, onClose, dialogRef });

  if (!isOpen) return null;

  return (
    <dialog
      ref={dialogRef}
      className="onhold-modal"
      aria-labelledby="onhold-modal-title"
      aria-describedby="onhold-modal-body"
    >
      <div className="onhold-modal-dialog">
        <div className="onhold-modal-icon" aria-hidden="true">
          <img src={ICON_BUTTON_ICONS.LOCK_FILL} alt="" />
        </div>
        <h3 id="onhold-modal-title" className="onhold-modal-title">
          AI Features On Hold
        </h3>
        <div className="onhold-modal-body" id="onhold-modal-body">
          <p>
            Your company&apos;s total token pool has been exhausted. The AI agent feature is paused
            until your limit is increased.
          </p>
          <p>You can still download company documents if download limits are available.</p>
        </div>
        <div className="onhold-modal-actions">
          <button type="button" className="onhold-modal-btn-secondary" onClick={onClose}>
            Close
          </button>
          <a
            className="onhold-modal-btn-primary"
            href={`mailto:${SUPPORT_EMAIL}`}
            aria-label={`Email support at ${SUPPORT_EMAIL}`}
          >
            Contact Support
          </a>
        </div>
      </div>
    </dialog>
  );
};

OnHoldActivationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
};

export default OnHoldActivationModal;
